import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'
import { ROTATION_STATUSES } from '~/components/routes/product-rotations/rotation-model'
import { RotationsListPage } from '~/components/routes/product-rotations/rotations-list-page'
import { ROTATIONS_READ } from '~/components/routes/product-rotations/rotation-ui'
import { withRoutePermissions } from '~/utils/rbac'

/** Rotations de produits (spec du 24/10, §8) : dernier onglet de la rubrique Catalogue. */
export const Route = createFileRoute('/_authenticated/product-rotations/')({
  staticData: {
    permission: ROTATIONS_READ,
  },
  component: ProductRotationsPage,
  validateSearch: z.object({
    status: z.enum(ROTATION_STATUSES).optional(),
    search: z.string().optional(),
  }),
})
withRoutePermissions(Route)

function ProductRotationsPage() {
  const navigate = Route.useNavigate()
  const { status, search = '' } = Route.useSearch()

  return (
    <RotationsListPage
      status={status}
      search={search}
      onSearchChange={(next) => navigate({ search: next, replace: true })}
    />
  )
}
